module.exports = __webpack_public_path__ + "img/cottage.a6faa6f6.svg";